import { render, staticRenderFns } from "./ProductsSectionSearch.vue?vue&type=template&id=182517ff&scoped=true&"
import script from "./ProductsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./ProductsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182517ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
